import { hasPendingTasksOf } from 'core/indicator/pending-tasks-redux';
import { connect } from 'react-redux';
import execute from '../grid/redux/action';
import { ID_MAPPING_REQUEST } from '../grid/redux/reducer';
import { close, open } from '../modal-upload/redux/actions';
import { FILE_UPLOAD_ID_MAPPING_REQUEST } from '../modal-upload/redux/types';
import IdMappingFormComponent from './id-mapping-form-component';
import {
  clear,
  clearAll,
  deleteQuery,
  populate,
  setValue,
  show,
  validateAndCreateQueryTag
} from './redux/action';

const mapStateToProps = (state: any, ownProps: any) => ({
  t: state.i18n.t,
  form: state.management.idMapping.form,
  isFetching:
    hasPendingTasksOf(FILE_UPLOAD_ID_MAPPING_REQUEST, state.pendingTasks) ||
    hasPendingTasksOf(ID_MAPPING_REQUEST, state.pendingTasks)
});

export default connect(mapStateToProps, {
  show,
  populate,
  setValue,
  clear,
  validateAndCreateQueryTag,
  deleteQuery,
  execute,
  open,
  close,
  clearAll
})(IdMappingFormComponent);
